export default __webpack_public_path__ + "static/media/protonet.dc198548.svg";